import axios from "axios"
import Chart from "chart.js"
import Papa from "papaparse"
import { BarChartModel } from "./../model/ChartModel"
import { ClientUtil } from "./clientUtil"

// import { SalesChart } from "saleschart"
export class SalesChart {

  /**
   * 売れ筋上位を表示
   * @param ctx canvasのコンテキスト
   */
  public static hotSale(ctx: CanvasRenderingContext2D) {

    const LIMIT = 6
    const origindata = `"C-00001","プリントＴシャツ（コットン素材）",73400,41
"C-00002","アンダーシャツ（綿素材）",243000,270
"C-00003","インポートＴシャツ（コットン素材）",103850,33
"J-10001","クリアーファイルK-77",1414530,4170
"J-10002","フロッピーディスクケースH-3.5",598500,350
"J-10003","ワープロ用感熱紙WRP-123",324000,58200
"J-10004","バインダーB-125",3383640,3780
"J-10005","コンピュータ用紙STKH-15INT",571200,121800
"J-10006","付箋シール２色HS-002",993060,3320
"J-10007","メモ用便箋MB-120",467780,2490
"J-10008","三角スケール50-SRM",192040,310
"J-10009","コンパス162KMPS",58090,160
"K-10001","全自動洗濯機",2546600,32
"K-10002","スチームアイロンIRS-5000CL-WT",260000,15
"K-10003","４ドア冷蔵庫NANR-D32-TWレッド",1870000,10
"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック",2088000,9
"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト",2785360,20
"K-10006","電気ジャーポットZJ21A-Wホワイト",343250,15
"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S",4154800,17
"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S",2700880,13
"O-10004","文字放送内蔵テレビNATH-29TA2",7411500,31
"O-10005","文字放送内蔵テレビNATH-26TA2",1368000,6
"O-10006","文字放送内蔵テレビNATH-19T2",9124500,27
"O-10007","ニューオーディオコンポCD300NASC-CD300-K",1371402,13
"O-10008","ニューオーディオコンポCD650NASC-CD650-K",1804142,12
"O-10009","フルオートプレイヤーNASL-J100R-K",564102,30
"O-10011","フルレンジスピーカーシステムNASB-S30-K",178500,6
"O-10012","フルレンジスピーカーシステムNASB-S50-K",546056,14
"O-10013","ステレオグラフィックイコライザーNASH-E70A-K",692520,20
"O-10014","コンポーネントテレフォンNASH-TL80-K",156016,4
"O-10015","スピーカーシステムNASB-MX7-M",284050,5
"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック",1244760,44
"O-10020","ヘッドホンステレオNARX-SR24-Kブラック",380000,10
"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック",122550,10
"O-10023","ステレオラジオNARX-FM14-Kブラック",307840,25
"O-10024","ステレオラジオNARX-FM14-Wホワイト",37632,3
"O-10025","ステレオラジオNARX-FM24-Kブラック",468642,22
"S-10001","鰹節ギフト用",195300,3100
"S-10002","ブイヨン",167400,1860
"S-10003","乾燥海草サラダ",167400,620
"S-10011","海苔玉ふりかけ",232760,1100
"S-10012","鱈子ふりかけ",232760,1100
"S-10013","胡麻塩ふりかけ",265080,1260
"S-10033","鉄観音鳥龍茶",242112,312
"S-10034","杜仲茶",468880,576
"S-10035","プアル茶",322688,432
"S-10041","インスタントコーヒー",1093500,810
"S-10042","健康コーヒー用シュガー",819000,910
"S-10043","健康クリームミルク",819000,910
"SET-J01","事務用品ビジネスパック",2588400,100
"SET-J02","用紙ビジネスパック",2298600,100
"SET-S01","贈答ギフトセット",393300,50
"SET-S02","贈答ふりかけ３点セット",1117800,100
"SET-S03","贈答コーヒーギフトセット",1467600,50
"SET-S04","贈答お茶漬けセット",277300,100
"SET-S05","贈答健康茶ギフトセット",434700,100
"T-00001","花１００００円ＳＥＴ",285000,30
"T-00002","観葉植物",560500,59`
    const data = { labels: [], data: [] } as { labels: string[], data: number[] }
    const parseData = Papa.parse(origindata, { dynamicTyping: true })
    // console.log(parseData)
    // 順にプッシュして最後切り捨てればOK
    parseData.data.sort((a, b) => {
      return b[2] - a[2]
    })

    for (let i = 0; i < LIMIT; i++) {
      const datum = parseData.data[i]
      const id = datum[0]
      const name = datum[1]
      const price = datum[2]
      const num = datum[3]
      data.data.push(price)
      data.labels.push(name)
    }

    const myChart: Chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: data.labels,
        datasets: [{
          label: "売れ筋上位",
          data: data.data,
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)",
          ],
          borderColor: [
            "rgba(255,99,132,1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        }],
      },
      options: {
        responsive: true,
        scales: {
          xAxes: [{
            ticks: {
              maxRotation: 90,
              minRotation: 90,
              callback: (val) => {
                if (val.length > 10) {
                  return [val.substr(0, 10), val.substr(10)]
                } else {
                  return val
                }
              },
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      },
    })
  }


  /**
   * 売上構成比(得意先別)
   */
  public static salesRateByCustomer(ctx: CanvasRenderingContext2D) {
    const dataLabelPlugin = {
      afterDatasetsDraw: (chart: Chart, easing: Chart.Easing) => {
        // To only draw at the end of animation, check for easing === 1
        const cx = chart.ctx!

        chart.data.datasets!.forEach((dataset, i) => {
          let dataSum = 0
          const datasetData = dataset.data as number[]
          datasetData.forEach((element: number) => {
            dataSum += element
          })
          const meta = chart.getDatasetMeta(i)
          if (!meta.hidden) {
            meta.data.forEach((element, index: number) => {
              // Draw the text in black, with the specified font
              cx.fillStyle = "rgb(0, 0, 0)"

              const fontSize = 12
              const fontStyle = "normal"
              const fontFamily = "Helvetica Neue"
              cx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

              // Just naively convert to string for now
              const dataString = (dataset.data as number[])[index].toString()
              const dispText = (Math.round(datasetData[index] / dataSum * 100 * 10) / 10).toString() + "%"

              // Make sure alignment settings are correct
              cx.textAlign = "center"
              cx.textBaseline = "middle"

              const padding = 5
              const position = (element as any).tooltipPosition()
              cx.fillText(dispText, position.x, position.y - (fontSize / 2) - padding)
            })
          }
        })
      },
    }
    const LIMIT = 10
    const origindata = `"00000001","太平洋販売株式会社",5349946
"00000002","株式会社岩手産業",10392350
"00000004","群馬事務機株式会社",8484040
"00000005","埼玉商事株式会社",8814980
"00000006","株式会社千葉デンキ",15685450
"00000007","東京事務機販売株式会社",5389950
"00000008","神奈川物産株式会社",2128312
"00000009","新潟工業株式会社",6110000
"00000010","石川販売株式会社",2282600
"00000011","名古屋電機商事株式会社",6614676
"00000012","大阪事務株式会社",2063774
"00000013","梅田商事株式会社",3771942
"00000014","京都システム株式会社",951994
"00000016","株式会社広島興産",11270348
"00000017","テック高松株式会社",5985448
"00000018","株式会社福岡屋",6497400
"00000020","鹿児島文具",3545432
"00000021","高松屋百貨店株式会社",16637720
"00000022","新宿フラワー株式会社",2318000
"00000023","T-SHOP株式会社",806850
"00000030","渋谷フラワー株式会社",3431100
"00000508","札幌工務店株式会社",114000`

    const labels: string[] = []
    const data: number[] = []
    const parseData = Papa.parse(origindata, { dynamicTyping: true })
    // console.log(parseData)
    parseData.data.sort((a, b) => {
      return b[2] - a[2]
    })

    for (let i = 0; i < parseData.data.length; i++) {
      const datum = parseData.data[i]
      const id = datum[0]
      const name = datum[1]
      const price = datum[2]

      if (i < LIMIT - 1) {
        data.push(price)
        labels.push(name)
      } else if (i === LIMIT - 1) {
        data.push(price)
        labels.push("その他")
      } else {
        // その他にまとめる
        data[data.length - 1] += price
      }
    }
    //
    const myPieChart = new Chart(ctx, {
      type: "pie",
      data: {
        datasets: [{
          data: data,
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)",
            "rgba(255, 99, 132, 0.6)",
            "rgba(54, 162, 235, 0.6)",
            "rgba(255, 206, 86, 0.6)",
          ],
        }],
        labels: labels,
      },
      options: {
        title: {
          display: true,
          text: "取引先別売上構成比",
        },
      },
      plugins: [dataLabelPlugin],
    })
  }

  public static salesByPeriod(ctx: CanvasRenderingContext2D) {

    return new Promise<{ labels: string[], price: number[] }>((resolve, reject) => {
      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
        url: "/api/salesbyperiod",
      }).then((response) => {
        const salesData = response.data as number[]
        console.log(salesData)

        const totalSalesData: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        totalSalesData[0] = salesData[0]
        totalSalesData[1] = totalSalesData[0] + salesData[1]
        totalSalesData[2] = totalSalesData[1] + salesData[2]
        totalSalesData[3] = totalSalesData[2] + salesData[3]
        totalSalesData[4] = totalSalesData[3] + salesData[4]
        totalSalesData[5] = totalSalesData[4] + salesData[5]
        totalSalesData[6] = totalSalesData[5] + salesData[6]
        totalSalesData[7] = totalSalesData[6] + salesData[7]
        totalSalesData[8] = totalSalesData[7] + salesData[8]
        totalSalesData[9] = totalSalesData[8] + salesData[9]
        totalSalesData[10] = totalSalesData[9] + salesData[10]
        totalSalesData[11] = totalSalesData[10] + salesData[11]
        // totalSalesData[12] = totalSalesData[11] + salesData[12]

        // salesData.pop()
        // totalSalesData.pop()

        const salesChart = new Chart(ctx, {
          type: "bar",
          data: {
            datasets: [{
              label: "単月売上",
              data: salesData,
              backgroundColor: "rgba(255, 99, 132, 0.2)",

            }, {
              label: "合計",
              data: totalSalesData,
              backgroundColor: "rgba(54, 162, 235, 0.2)",

              // このデータセットを線グラフにする
              type: "line",
            }],
            labels: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          },
          options: {
            onClick: () => {
              // document.location.href = "/demand"
            },
            scales: {
              yAxes: [{
                ticks: {
                  // beginAtZero: true,
                },
              }],
            },
          },
        })
        salesChart.options.onClick = () => {
          document.location.href = "/demand"
        }
        resolve()
      })
    })
  }

  public static salesTrendsByProduct(ctx: CanvasRenderingContext2D) {

    const origindata = ``

    //
    // const myChart = new Chart(ctx, {
    //   type: "pie",
    //   data: data,
    //   options: options
    // })
  }

  public static salesTrendsByCustomer(ctx: CanvasRenderingContext2D) {

    const origindata = this.csvdata
    const salesData1: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    const salesData2: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    const salesData3: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    const salesData4: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    const parseData = Papa.parse(origindata, { dynamicTyping: true })
    console.log(parseData)
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < parseData.data.length; i++) {
      const datum = parseData.data[i]
      const date = new Date(datum[0])
      const month = date.getMonth()
      const productCode = datum[1]
      const productName = datum[2]
      const customerCode = datum[3]
      const customerName = datum[4]
      const staffCode = datum[5]
      const staffName = datum[6]
      const price = datum[7]
      if (customerName === "高松屋百貨店株式会社") {
        salesData1[month] += price
      } else if (customerName === "株式会社千葉デンキ") {
        salesData2[month] += price
      } else if (customerName === "株式会社広島興産") {
        salesData3[month] += price
      } else if (customerName === "埼玉商事株式会社") {
        salesData4[month] += price
      }
    }

    const salesChart = new Chart(ctx, {
      type: "line",
      data: {
        datasets: [{
          label: "高松屋百貨店株式会社",
          data: salesData1,
          borderColor: "rgba(255, 99, 132, 0.8)",
          fill: false,

        }, {
          label: "株式会社千葉デンキ",
          data: salesData2,
          borderColor: "rgba(54, 162, 235, 0.8)",
          fill: false,

        }, {
          label: "株式会社広島興産",
          data: salesData3,
          borderColor: "rgba(255, 206, 86, 0.8)",
          fill: false,

        }, {
          label: "埼玉商事株式会社",
          data: salesData4,
          borderColor: "rgba(75, 192, 192, 0.8)",
          fill: false,

        }],
        labels: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      },
      options: {
        title: {
          display: true,
          text: "売上推移",
          padding: 3,
          fontSize: 20,
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      },
    })

  }

  /**
   * 売上実績
   * @param ctx
   */
  public static salesPeformance(ctx: CanvasRenderingContext2D) {

    const origindata = this.csvdata
    const numData: number[] = []
    const dataset = [
      { // 取引先のデータ
        label: "個数",
        borderWidth: 1,
        backgroundColor: "red",
        borderColor: "red",
        data: numData,
      }]
    // labels: 商品
    // label: 取引先
    // data: 量 商品毎

    // TODO: 全期間から季節の補正とかがいるよ
    // 1ヶ月あたりの需要 とりあえず平均をとる
    // 縦:商品 横:取引先積み上げ量

    // まず商品labelsから作成
    const parseData = Papa.parse(origindata, { dynamicTyping: true })
    console.log(parseData)
    let productLabels: string[] = []
    // tslint:disable-next-line:prefer-for-of
    parseData.data.forEach((datum) => {
      const productName = datum[2]
      productLabels.push(productName)
    })
    productLabels = productLabels.filter((x, i, self) => {
      return self.indexOf(x) === i
    })

    productLabels.forEach((product) => {
      numData.push(0)
    })

    // 商品毎売上
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < parseData.data.length; i++) {
      const datum = parseData.data[i]
      const date = new Date(datum[0])
      const month = date.getMonth()
      const productCode = datum[1]
      const productName = datum[2]
      const customerCode = datum[3]
      const customerName = datum[4]
      const staffCode = datum[5]
      const staffName = datum[6]
      const price = datum[7]
      const index = productLabels.indexOf(productName)
      if (index !== -1) {
        numData[index] += 1
      }
    }

    // 平均をとる
    // for (let i = 0; i < numData.length; i++) {
    //   numData[i] = Math.ceil(numData[i] / 12)
    // }

    const mychart = new Chart(ctx, {
      type: "horizontalBar",
      data: {
        labels: productLabels,
        datasets: dataset,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "売上実績",
          padding: 3,
          fontSize: 20,
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              // barThickness: 16,
              scaleLabel: {
                display: true,
                // labelString: "取引先",
                fontSize: 16,
              },
            },
          ], xAxes: [
            {
              stacked: true,
              scaleLabel: {
                display: false,
                labelString: "個数",
                fontSize: 16,
              },
            },
          ],
        },
        legend: {
          labels: {
            boxWidth: 30,
            padding: 20,
          },
          display: true,
        },
        // tooltips: {
        //   mode: "label",
        // },
      },
    })
  }

  /**
   * 需要予測
   * @param ctx
   */
  public static chartdemand(ctx: CanvasRenderingContext2D, from: string, to: string) {

    return new Promise<{ [key: string]: { labels: string[], num: number[], actual: number[] } }
    >((resolve, reject) => {
      // api通信
      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          from: from,
          to: to,
        },
        url: "/api/demand",
      }).then((response) => {
        const data = response.data as { [key: string]: { labels: string[], num: number[], actual: number[] } }

        resolve(data)
      })
    })

  }

  /**
   * 売上実績トップ10
   * @param ctx canvasのコンテキスト
   */
  public static topsales(ctx: CanvasRenderingContext2D) {

    axios({
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
      url: "/api/sales/topsalesitem",
    }).then((response) => {
      const data = response.data as { labels: string[], count: number[] }
      // const totalcount = data.count.reduce((a, x) => a += x, 0)
      console.log(data)
      const dataset = [
        {
          label: "数量",
          borderWidth: 1,
          backgroundColor: "rgba(255, 99, 132, 1)",
          borderColor: "gray",
          data: data.count,
        }]
      const mychart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: data.labels,
          datasets: dataset,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "売上上位商品(2019/01〜2019/12)",
            padding: 3,
            fontSize: 20,
          },
          scales: {
            yAxes: [
              {
                stacked: true,
                // barThickness: 16,
                scaleLabel: {
                  display: true,
                  // labelString: "取引先",
                  fontSize: 16,
                },
              },
            ],
            xAxes: [{
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                callback: (val) => {
                  if (val.length > 5) {
                    return [val.substr(0, 5), val.substr(5)]
                  } else {
                    return val
                  }
                },
              },
            }],
          },
          legend: {
            labels: {
              boxWidth: 30,
              padding: 20,
            },
            display: true,
          },
          // tooltips: {
          //   mode: "label",
          // },
        },
      })

      ClientUtil.loadStop()
    })
  }
  /**
   * 売上実績トップ10の推移
   * @param ctx canvasのコンテキスト
   */
  public static trendsInSales(ctx: CanvasRenderingContext2D, from: string, to: string) {

    return new Promise<{
      labels: string[],
      data: { [key: string]: { count: number[] } },
    }>((resolve, reject) => {
      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          from: from,
          to: to,
        },
        url: "/api/sales/trendsinsales",
      }).then((response) => {
        const data = response.data as { labels: string[], data: { [key: string]: { count: number[] } } }
        // const totalcount = data.count.reduce((a, x) => a += x, 0)
        console.log(data)
        // const dataset: Array<{
        //   label: string;
        //   borderWidth: number;
        //   backgroundColor: string;
        //   borderColor: string;
        //   data: number[];
        // }> = []

        // const colors = [
        //   "rgba(255, 99, 132, 0.6)",
        //   "rgba(54, 162, 235, 0.6)",
        //   "rgba(255, 206, 86, 0.6)",
        //   "rgba(75, 192, 192, 0.6)",
        //   "rgba(153, 102, 255, 0.6)",
        //   "rgba(255, 159, 64, 0.6)",
        //   "rgba(255, 99, 132, 1)",
        //   "rgba(54, 162, 235, 1)",
        //   "rgba(255, 206, 86, 1)",
        //   "rgba(75, 192, 192, 1)",
        //   "rgba(153, 102, 255, 1)",
        // ]
        // for (const key in data) {
        //   if (data.hasOwnProperty(key)) {
        //     const datum = data[key]
        //     dataset.push({
        //       label: key,
        //       borderWidth: 1,
        //       backgroundColor: "transparent",
        //       borderColor: colors.pop()!,
        //       data: datum.count,
        //     })
        //   }
        // }
        // const mychart = new Chart(ctx, {
        //   type: "line",
        //   data: {
        //     labels: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
        //     datasets: dataset,
        //   },
        //   options: {
        //     responsive: true,
        //     maintainAspectRatio: false,
        //     title: {
        //       display: true,
        //       text: "売上推移",
        //       padding: 3,
        //       fontSize: 20,
        //     },
        //     scales: {
        //       yAxes: [
        //         {
        //           // stacked: true,
        //           // barThickness: 16,
        //           scaleLabel: {
        //             display: true,
        //             // labelString: "取引先",
        //             fontSize: 16,
        //           },
        //         },
        //       ],
        //       xAxes: [{
        //         ticks: {
        //           maxRotation: 0,
        //           minRotation: 0,
        //           callback: (val) => {
        //             if (val.length > 5) {
        //               return [val.substr(0, 5), val.substr(5)]
        //             } else {
        //               return val
        //             }
        //           },
        //         },
        //       }],
        //     },
        //     legend: {
        //       labels: {
        //         boxWidth: 30,
        //         padding: 20,
        //       },
        //       display: true,
        //     },
        //     // tooltips: {
        //     //   mode: "label",
        //     // },
        //   },
        // })

        // ClientUtil.loadStop()
        resolve(data)
      })
    })
  }

  /**
   * ABC分析
   * @param ctx canvasのコンテキスト
   */
  public static abc(ctx: CanvasRenderingContext2D) {


    return new Promise<{ labels: string[], price: number[] }>((resolve, reject) => {
      axios({
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
        url: "/api/sales/abc",
      }).then((response) => {
        const data = response.data as { labels: string[], price: number[] }
        resolve(data)

      })
    })
  }

  /**
   *
   * @param ctx canvasのコンテキスト
   */
  public static charttemplate(ctx: CanvasRenderingContext2D) {

    axios({
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
      // data: {
      //   src: this.text,
      //   lang: this.srcLang,
      //   referrer: document.referrer,
      //   apikey: apikey,
      // },
      url: "/api/sales",
    }).then((response) => {
      //
      // const myChart = new Chart(ctx, {
      //   type: "pie",
      //   data: data,
      //   options: options
      // })
    })
  }

  public static csvdata = `2019/01/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",234000
2019/01/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",600000
2019/01/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3300000
2019/01/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",145200
2019/01/01,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",220000
2019/01/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",20000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/01/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",52500
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/01/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",67500
2019/01/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",72000
2019/01/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",20900
2019/01/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",160000
2019/01/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",129000
2019/01/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",390000
2019/01/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",1500000
2019/01/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",231000
2019/01/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",378000
2019/01/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",150000
2019/01/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",211200
2019/01/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",168480
2019/01/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1245000
2019/01/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",95000
2019/01/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",120000
2019/01/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",320000
2019/01/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",170000
2019/01/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",35000
2019/01/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1080000
2019/01/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",225000
2019/01/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",31000
2019/01/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",7200
2019/01/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",108800
2019/01/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",85500
2019/01/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",88500
2019/01/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",175000
2019/01/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",300000
2019/01/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/01/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",240000
2019/01/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",480000
2019/01/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",240000
2019/01/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",0
2019/01/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",780000
2019/01/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1020000
2019/01/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",145000
2019/01/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",77500
2019/01/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",2000000
2019/01/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",2000000
2019/01/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",280000
2019/01/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",140000
2019/01/11,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",210000
2019/01/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",170000
2019/01/11,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",194400
2019/01/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",30000
2019/01/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",18000
2019/01/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/01/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",38000
2019/01/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",144000
2019/01/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",216000
2019/01/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",360000
2019/01/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",110000
2019/01/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",266400
2019/01/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",294000
2019/01/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",245000
2019/01/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",10000
2019/01/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",150000
2019/01/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",70000
2019/01/12,"S-10002","ブイヨン","00000012","大阪事務株式会社","0401","山下　和伸",10000
2019/01/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/01/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/01/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",110000
2019/01/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",59000
2019/01/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",35400
2019/01/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",147000
2019/01/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2250800
2019/01/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2498500
2019/01/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",427500
2019/01/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1215000
2019/01/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1595250
2019/01/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",301500
2019/01/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",472500
2019/01/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",105000
2019/01/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",54000
2019/01/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",60000
2019/01/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/01/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",780000
2019/01/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",432000
2019/01/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",84000
2019/01/16,"O-10018","ヘッドホンステレオNARQ-JR4-Sシルバー","00000016","株式会社広島興産","0501","岸川　良介",87000
2019/01/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",168000
2019/01/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",11400
2019/01/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",49600
2019/01/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36000
2019/01/18,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",126000
2019/01/18,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",324000
2019/01/18,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",225000
2019/01/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",490000
2019/01/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",700000
2019/01/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",300800
2019/01/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",132000
2019/01/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",237600
2019/01/20,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",32000
2019/01/20,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",84000
2019/01/20,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",63000
2019/01/20,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",230000
2019/01/22,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",830000
2019/01/22,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",420000
2019/01/22,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1320000
2019/01/22,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",312000
2019/01/22,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",1050000
2019/01/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2600000
2019/01/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",133000
2019/01/22,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000002","株式会社岩手産業","0102","佐藤　政夫",378000
2019/01/22,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",84000
2019/01/22,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",266400
2019/01/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",414400
2019/01/22,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",196000
2019/01/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",215600
2019/01/22,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",215600
2019/01/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",196000
2019/01/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",98750
2019/01/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",315000
2019/01/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1000000
2019/01/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",660000
2019/01/23,"S-10031","緑茶","00000012","大阪事務株式会社","0401","山下　和伸",8800
2019/01/23,"S-10032","ダージリン紅茶","00000012","大阪事務株式会社","0401","山下　和伸",7800
2019/01/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",83200
2019/01/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",86000
2019/01/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",70200
2019/01/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",178500
2019/01/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",172800
2019/01/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",84000
2019/01/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",34200
2019/01/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",675000
2019/01/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",294000
2019/01/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",56400
2019/01/25,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",262500
2019/01/25,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",270000
2019/01/25,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/01/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",41800
2019/01/25,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",130000
2019/01/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",231000
2019/01/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",140000
2019/01/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",194400
2019/01/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",255000
2019/01/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",237000
2019/01/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",616000
2019/01/26,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",250000
2019/01/26,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",150000
2019/01/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",78000
2019/01/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",49000
2019/01/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",10000
2019/01/29,"K-10001","全自動洗濯機","00000003","株式会社茨城電機","0201","大田　孝一",85000
2019/01/29,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000003","株式会社茨城電機","0201","大田　孝一",240000
2019/01/29,"O-10001","ＡＶ＆ドルビーサラウンドテレビ３３NATH-33F1","00000003","株式会社茨城電機","0201","大田　孝一",380000
2019/01/29,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000003","株式会社茨城電機","0201","大田　孝一",35000
2019/01/29,"S-10031","緑茶","00000024","東京国際物流株式会社","0210","川口　七恵",5280
2019/01/29,"S-10033","鉄観音鳥龍茶","00000024","東京国際物流株式会社","0210","川口　七恵",4920
2019/01/29,"S-10034","杜仲茶","00000024","東京国際物流株式会社","0210","川口　七恵",5280
2019/01/29,"S-10035","プアル茶","00000024","東京国際物流株式会社","0210","川口　七恵",4800
2019/02/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",234000
2019/02/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",600000
2019/02/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3300000
2019/02/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",154000
2019/02/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",123200
2019/02/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",136400
2019/02/01,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",120000
2019/02/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",50000
2019/02/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",420000
2019/02/03,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",157500
2019/02/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",56000
2019/02/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",518400
2019/02/03,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",108000
2019/02/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",67500
2019/02/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",72000
2019/02/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",17100
2019/02/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",88000
2019/02/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",89440
2019/02/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",327600
2019/02/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",500000
2019/02/04,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",840000
2019/02/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",198000
2019/02/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",378000
2019/02/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",150000
2019/02/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",240000
2019/02/04,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",278640
2019/02/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",187200
2019/02/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1245000
2019/02/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",95000
2019/02/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",120000
2019/02/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",250000
2019/02/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",170000
2019/02/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",35000
2019/02/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1080000
2019/02/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",225000
2019/02/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",31000
2019/02/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",7200
2019/02/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",119000
2019/02/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",85500
2019/02/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",94400
2019/02/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",210000
2019/02/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",300000
2019/02/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/02/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",240000
2019/02/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",480000
2019/02/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",240000
2019/02/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",0
2019/02/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",780000
2019/02/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1020000
2019/02/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",145000
2019/02/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",77500
2019/02/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",2000000
2019/02/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",2500000
2019/02/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",700000
2019/02/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",140000
2019/02/11,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",210000
2019/02/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",340000
2019/02/11,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",194400
2019/02/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",27000
2019/02/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",18000
2019/02/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/02/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",38000
2019/02/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",144000
2019/02/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",216000
2019/02/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",360000
2019/02/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",110000
2019/02/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",296000
2019/02/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",333200
2019/02/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",98000
2019/02/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",16000
2019/02/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",90000
2019/02/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",63000
2019/02/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/02/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/02/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",110000
2019/02/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",59000
2019/02/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",35400
2019/02/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",147000
2019/02/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2250800
2019/02/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2498500
2019/02/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",427500
2019/02/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1215000
2019/02/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1595250
2019/02/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",301500
2019/02/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",472500
2019/02/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",94500
2019/02/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",32400
2019/02/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",48000
2019/02/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",32300
2019/02/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",780000
2019/02/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",288000
2019/02/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",140000
2019/02/16,"O-10018","ヘッドホンステレオNARQ-JR4-Sシルバー","00000016","株式会社広島興産","0501","岸川　良介",145000
2019/02/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",168000
2019/02/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",11400
2019/02/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",49600
2019/02/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36000
2019/02/18,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",126000
2019/02/18,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",324000
2019/02/18,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",225000
2019/02/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",490000
2019/02/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",700000
2019/02/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",300800
2019/02/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",110000
2019/02/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",158400
2019/02/20,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",32000
2019/02/20,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",84000
2019/02/20,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",63000
2019/02/20,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",200000
2019/02/22,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",747000
2019/02/22,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",420000
2019/02/22,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1100000
2019/02/22,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",96000
2019/02/22,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",420000
2019/02/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2600000
2019/02/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",133000
2019/02/22,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000002","株式会社岩手産業","0102","佐藤　政夫",378000
2019/02/22,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",84000
2019/02/22,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",266400
2019/02/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",414400
2019/02/22,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",196000
2019/02/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",215600
2019/02/22,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",215600
2019/02/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",196000
2019/02/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",98750
2019/02/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",525000
2019/02/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",2000000
2019/02/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",1650000
2019/02/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",83200
2019/02/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",86000
2019/02/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",70200
2019/02/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",178500
2019/02/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",172800
2019/02/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",84000
2019/02/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",34200
2019/02/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",675000
2019/02/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",294000
2019/02/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",56400
2019/02/25,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",262500
2019/02/25,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",270000
2019/02/25,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/02/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",41800
2019/02/25,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",130000
2019/02/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",231000
2019/02/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",164500
2019/02/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",194400
2019/02/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",306000
2019/02/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",234000
2019/02/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",448000
2019/02/26,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",210000
2019/02/26,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",150000
2019/02/27,"K-10001","全自動洗濯機","00000003","株式会社茨城電機","0201","大田　孝一",85000
2019/02/27,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000003","株式会社茨城電機","0201","大田　孝一",240000
2019/02/27,"O-10001","ＡＶ＆ドルビーサラウンドテレビ３３NATH-33F1","00000003","株式会社茨城電機","0201","大田　孝一",380000
2019/02/27,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000003","株式会社茨城電機","0201","大田　孝一",35000
2019/02/27,"S-10031","緑茶","00000024","東京国際物流株式会社","0210","川口　七恵",1760
2019/02/27,"S-10033","鉄観音鳥龍茶","00000024","東京国際物流株式会社","0210","川口　七恵",1640
2019/02/27,"S-10034","杜仲茶","00000024","東京国際物流株式会社","0210","川口　七恵",1760
2019/02/27,"S-10035","プアル茶","00000024","東京国際物流株式会社","0210","川口　七恵",1600
2019/02/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",36000
2019/02/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",78000
2019/02/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",49000
2019/02/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",31000
2019/03/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",176000
2019/03/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",123200
2019/03/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",123200
2019/03/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315000
2019/03/03,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",94500
2019/03/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",52500
2019/03/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/03/03,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",108000
2019/03/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",67500
2019/03/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",48000
2019/03/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",13300
2019/03/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",88000
2019/03/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",89440
2019/03/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",327600
2019/03/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",250000
2019/03/04,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",840000
2019/03/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",132000
2019/03/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",302400
2019/03/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",120000
2019/03/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",211200
2019/03/04,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",247680
2019/03/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",168480
2019/03/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1245000
2019/03/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",95000
2019/03/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",120000
2019/03/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",220000
2019/03/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",136000
2019/03/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",35000
2019/03/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1080000
2019/03/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",225000
2019/03/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",24800
2019/03/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",5760
2019/03/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",81600
2019/03/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",79800
2019/03/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",53100
2019/03/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",210000
2019/03/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",300000
2019/03/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/03/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",240000
2019/03/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",480000
2019/03/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",240000
2019/03/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",0
2019/03/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",780000
2019/03/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1020000
2019/03/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",145000
2019/03/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",77500
2019/03/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",2000000
2019/03/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",1750000
2019/03/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",140000
2019/03/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",140000
2019/03/11,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",210000
2019/03/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",340000
2019/03/11,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",194400
2019/03/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",27000
2019/03/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",18000
2019/03/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/03/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",38000
2019/03/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",108000
2019/03/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",216000
2019/03/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",288000
2019/03/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",110000
2019/03/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",148000
2019/03/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",245000
2019/03/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",196000
2019/03/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",30000
2019/03/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",105000
2019/03/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",70000
2019/03/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/03/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/03/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",110000
2019/03/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",47200
2019/03/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",23600
2019/03/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",105000
2019/03/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2250800
2019/03/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2498500
2019/03/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",427500
2019/03/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1215000
2019/03/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1595250
2019/03/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",301500
2019/03/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",472500
2019/03/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",105000
2019/03/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",54000
2019/03/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",60000
2019/03/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/03/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",780000
2019/03/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",288000
2019/03/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",140000
2019/03/16,"O-10018","ヘッドホンステレオNARQ-JR4-Sシルバー","00000016","株式会社広島興産","0501","岸川　良介",145000
2019/03/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",120000
2019/03/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",11400
2019/03/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",43400
2019/03/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36000
2019/03/18,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",126000
2019/03/18,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",324000
2019/03/18,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",225000
2019/03/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",490000
2019/03/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",700000
2019/03/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",300800
2019/03/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",132000
2019/03/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",237600
2019/03/20,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",20000
2019/03/20,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",60000
2019/03/20,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",52500
2019/03/20,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",230000
2019/03/22,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",830000
2019/03/22,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",420000
2019/03/22,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1320000
2019/03/22,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",96000
2019/03/22,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",1050000
2019/03/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2080000
2019/03/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",95000
2019/03/22,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000002","株式会社岩手産業","0102","佐藤　政夫",378000
2019/03/22,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",84000
2019/03/22,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",266400
2019/03/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",414400
2019/03/22,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",196000
2019/03/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",215600
2019/03/22,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",215600
2019/03/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",196000
2019/03/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",98750
2019/03/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",315000
2019/03/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1000000
2019/03/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",660000
2019/03/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",83200
2019/03/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",86000
2019/03/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",70200
2019/03/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",157500
2019/03/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",172800
2019/03/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",72000
2019/03/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",19000
2019/03/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",675000
2019/03/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",294000
2019/03/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",56400
2019/03/25,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",262500
2019/03/25,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",270000
2019/03/25,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/03/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",41800
2019/03/25,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",130000
2019/03/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",105000
2019/03/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",164500
2019/03/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",162000
2019/03/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",306000
2019/03/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",234000
2019/03/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",616000
2019/03/26,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",200000
2019/03/26,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",120000
2019/03/27,"K-10001","全自動洗濯機","00000003","株式会社茨城電機","0201","大田　孝一",85000
2019/03/27,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000003","株式会社茨城電機","0201","大田　孝一",240000
2019/03/27,"O-10001","ＡＶ＆ドルビーサラウンドテレビ３３NATH-33F1","00000003","株式会社茨城電機","0201","大田　孝一",380000
2019/03/27,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000003","株式会社茨城電機","0201","大田　孝一",35000
2019/03/27,"S-10031","緑茶","00000024","東京国際物流株式会社","0210","川口　七恵",5280
2019/03/27,"S-10033","鉄観音鳥龍茶","00000024","東京国際物流株式会社","0210","川口　七恵",4920
2019/03/27,"S-10034","杜仲茶","00000024","東京国際物流株式会社","0210","川口　七恵",5280
2019/03/27,"S-10035","プアル茶","00000024","東京国際物流株式会社","0210","川口　七恵",4800
2019/03/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",36000
2019/03/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",78000
2019/03/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",49000
2019/03/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",10000
2019/04/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0102","佐藤　政夫",234000
2019/04/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",242250
2019/04/01,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000006","株式会社千葉デンキ","0203","河合　正信",627000
2019/04/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3990000
2019/04/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0101","木村　洋一",88000
2019/04/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",80800
2019/04/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0101","木村　洋一",88000
2019/04/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",80800
2019/04/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0101","木村　洋一",132000
2019/04/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",121200
2019/04/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",190000
2019/04/02,"C-00001","プリントＴシャツ（コットン素材）","00000002","株式会社岩手産業","0106","諏訪　光",30000
2019/04/02,"C-00002","アンダーシャツ（綿素材）","00000002","株式会社岩手産業","0106","諏訪　光",90000
2019/04/02,"C-00003","インポートＴシャツ（コットン素材）","00000002","株式会社岩手産業","0106","諏訪　光",35000
2019/04/02,"K-10002","スチームアイロンIRS-5000CL-WT","00000002","株式会社岩手産業","0106","諏訪　光",190000
2019/04/02,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0106","諏訪　光",630000
2019/04/02,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0106","諏訪　光",600000
2019/04/02,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0106","諏訪　光",120000
2019/04/02,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0106","諏訪　光",1820000
2019/04/02,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0106","諏訪　光",132000
2019/04/02,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0106","諏訪　光",567000
2019/04/02,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0106","諏訪　光",300000
2019/04/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",210600
2019/04/03,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",106500
2019/04/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",45000
2019/04/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",541200
2019/04/03,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",112800
2019/04/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",56250
2019/04/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",61400
2019/04/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",19200
2019/04/03,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",73800
2019/04/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",79500
2019/04/03,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",79200
2019/04/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",85300
2019/04/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",77600
2019/04/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",119000
2019/04/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",507450
2019/04/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",278800
2019/04/04,"S-10001","鰹節ギフト用","00000001","太平洋販売株式会社","0102","佐藤　政夫",63000
2019/04/04,"S-10002","ブイヨン","00000001","太平洋販売株式会社","0102","佐藤　政夫",54000
2019/04/04,"S-10003","乾燥海草サラダ","00000001","太平洋販売株式会社","0102","佐藤　政夫",54000
2019/04/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1147500
2019/04/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",90000
2019/04/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",90000
2019/04/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",95000
2019/04/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",171000
2019/04/08,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",30000
2019/04/08,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",1082400
2019/04/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",30850
2019/04/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",3610
2019/04/08,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",725200
2019/04/08,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",122500
2019/04/08,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1715000
2019/04/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",110250
2019/04/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",94500
2019/04/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",94500
2019/04/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",210600
2019/04/09,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",154800
2019/04/09,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",163980
2019/04/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",304000
2019/04/09,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",89100
2019/04/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/04/09,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",27900
2019/04/09,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",92550
2019/04/10,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",19000
2019/04/10,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",85500
2019/04/10,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",33000
2019/04/10,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0105","増沢　輝",1245000
2019/04/10,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0105","増沢　輝",95000
2019/04/10,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",629000
2019/04/10,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0105","増沢　輝",96000
2019/04/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0203","河合　正信",1250000
2019/04/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",1222000
2019/04/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",1606500
2019/04/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",431460
2019/04/10,"S-10001","鰹節ギフト用","00000001","太平洋販売株式会社","0101","木村　洋一",68000
2019/04/10,"S-10002","ブイヨン","00000001","太平洋販売株式会社","0101","木村　洋一",57000
2019/04/10,"S-10003","乾燥海草サラダ","00000001","太平洋販売株式会社","0101","木村　洋一",59000
2019/04/10,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0101","木村　洋一",80000
2019/04/10,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0101","木村　洋一",86000
2019/04/10,"S-10035","プアル茶","00000001","太平洋販売株式会社","0101","木村　洋一",78000
2019/04/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",142500
2019/04/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",15000
2019/04/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",18240
2019/04/11,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",47500
2019/04/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",75620
2019/04/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",227240
2019/04/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",380000
2019/04/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",122550
2019/04/12,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0103","古橋　圭子",525000
2019/04/12,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0402","牧田　和彦",157500
2019/04/12,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0103","古橋　圭子",595000
2019/04/12,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0103","古橋　圭子",52500
2019/04/12,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0402","牧田　和彦",140000
2019/04/12,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",120000
2019/04/12,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0103","古橋　圭子",594000
2019/04/12,"J-10004","バインダーB-125","00000020","鹿児島文具","0402","牧田　和彦",378000
2019/04/12,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",218640
2019/04/12,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0103","古橋　圭子",94500
2019/04/12,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0402","牧田　和彦",180000
2019/04/12,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",150000
2019/04/12,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0103","古橋　圭子",378000
2019/04/12,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0402","牧田　和彦",90000
2019/04/12,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0103","古橋　圭子",323000
2019/04/12,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0402","牧田　和彦",28500
2019/04/12,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0103","古橋　圭子",124000
2019/04/12,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0103","古橋　圭子",3600
2019/04/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",130800
2019/04/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",130800
2019/04/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",130800
2019/04/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",87808
2019/04/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",37632
2019/04/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",152292
2019/04/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2070720
2019/04/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2298600
2019/04/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",393300
2019/04/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1117800
2019/04/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1467600
2019/04/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",277300
2019/04/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",434700
2019/04/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",105300
2019/04/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",55860
2019/04/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/04/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",546056
2019/04/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",156016
2019/04/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",321440
2019/04/16,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",202500
2019/04/16,"S-10041","インスタントコーヒー","00000007","東京事務機販売株式会社","0204","北野　紀男",213750
2019/04/16,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/04/16,"S-10042","健康コーヒー用シュガー","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/04/16,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/04/16,"S-10043","健康クリームミルク","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/04/17,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0104","佐藤　俊介",315000
2019/04/17,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0104","佐藤　俊介",270000
2019/04/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0104","佐藤　俊介",240000
2019/04/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",184200
2019/04/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0104","佐藤　俊介",28500
2019/04/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",9600
2019/04/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0104","佐藤　俊介",62000
2019/04/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",62400
2019/04/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0104","佐藤　俊介",36000
2019/04/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36400
2019/04/18,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0402","牧田　和彦",120000
2019/04/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",426024
2019/04/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",620024
2019/04/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",326502
2019/04/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",145920
2019/04/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",253080
2019/04/19,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0101","木村　洋一",206400
2019/04/19,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",190080
2019/04/19,"S-10035","プアル茶","00000001","太平洋販売株式会社","0101","木村　洋一",93600
2019/04/19,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",86400
2019/04/19,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0101","木村　洋一",666000
2019/04/19,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",405000
2019/04/19,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0101","木村　洋一",588000
2019/04/19,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/04/19,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0101","木村　洋一",588000
2019/04/19,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/04/20,"C-00001","プリントＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",25500
2019/04/20,"C-00002","アンダーシャツ（綿素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",76500
2019/04/20,"C-00003","インポートＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",29750
2019/04/20,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0202","山本　義治",35000
2019/04/20,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0202","山本　義治",1080000
2019/04/20,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0202","山本　義治",225000
2019/04/20,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",999600
2019/04/20,"K-10002","スチームアイロンIRS-5000CL-WT","00000002","株式会社岩手産業","0102","佐藤　政夫",170000
2019/04/20,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",561000
2019/04/20,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1176000
2019/04/20,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0302","中村　秀樹",600000
2019/04/20,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",106250
2019/04/20,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0302","中村　秀樹",120000
2019/04/20,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",831040
2019/04/20,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0105","増沢　輝",2600000
2019/04/20,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0302","中村　秀樹",1700000
2019/04/20,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0105","増沢　輝",133000
2019/04/20,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0102","佐藤　政夫",72000
2019/04/20,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0102","佐藤　政夫",216000
2019/04/20,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0102","佐藤　政夫",360000
2019/04/20,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0102","佐藤　政夫",110000
2019/04/20,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0302","中村　秀樹",82600
2019/04/20,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0302","中村　秀樹",35400
2019/04/20,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0302","中村　秀樹",147000
2019/04/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2430000
2019/04/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",124740
2019/04/22,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0204","北野　紀男",119000
2019/04/22,"S-10002","ブイヨン","00000010","石川販売株式会社","0204","北野　紀男",99750
2019/04/22,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0204","北野　紀男",103250
2019/04/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0204","北野　紀男",370000
2019/04/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",337500
2019/04/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0204","北野　紀男",245000
2019/04/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",225000
2019/04/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0204","北野　紀男",245000
2019/04/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",225000
2019/04/22,"U-10002","化粧箱","00000010","石川販売株式会社","0204","北野　紀男",98750
2019/04/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",725200
2019/04/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1038800
2019/04/23,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0204","北野　紀男",2500000
2019/04/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",1715000
2019/04/23,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0204","北野　紀男",420000
2019/04/23,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0204","北野　紀男",560000
2019/04/23,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0201","大田　孝一",132000
2019/04/23,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0201","大田　孝一",132000
2019/04/23,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0201","大田　孝一",132000
2019/04/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0201","大田　孝一",160000
2019/04/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",79500
2019/04/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0201","大田　孝一",172000
2019/04/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",85300
2019/04/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0201","大田　孝一",156000
2019/04/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",77600
2019/04/23,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",237500
2019/04/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",157950
2019/04/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",167580
2019/04/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",91200
2019/04/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",28500
2019/04/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",456000
2019/04/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",208620
2019/04/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0205","北野　まゆみ",392000
2019/04/24,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0205","北野　まゆみ",560000
2019/04/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",37620
2019/04/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0205","北野　まゆみ",319600
2019/04/25,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0206","小川　栄子",157500
2019/04/25,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0402","牧田　和彦",210000
2019/04/25,"J-10004","バインダーB-125","00000014","京都システム株式会社","0206","小川　栄子",162000
2019/04/25,"J-10004","バインダーB-125","00000020","鹿児島文具","0402","牧田　和彦",216000
2019/04/25,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0206","小川　栄子",90000
2019/04/25,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0206","小川　栄子",28500
2019/04/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0402","牧田　和彦",38000
2019/04/25,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0102","佐藤　政夫",600000
2019/04/25,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0301","川谷　実",525000
2019/04/25,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0301","川谷　実",1000000
2019/04/25,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0102","佐藤　政夫",450000
2019/04/25,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0102","佐藤　政夫",3960000
2019/04/25,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0301","川谷　実",1650000
2019/04/25,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0102","佐藤　政夫",196000
2019/04/25,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0102","佐藤　政夫",37600
2019/04/25,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0301","川谷　実",728000
2019/04/25,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0301","川谷　実",144000
2019/04/25,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0301","川谷　実",280000
2019/04/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",213000
2019/04/26,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",206400
2019/04/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",150000
2019/04/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",169200
2019/04/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",288000
2019/04/26,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",218640
2019/04/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",187500
2019/04/26,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",118800
2019/04/26,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",37200
2019/04/26,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0401","山下　和伸",996000
2019/04/26,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0401","山下　和伸",1100000
2019/04/26,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0401","山下　和伸",840000
2019/04/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",590400
2019/04/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",28500
2019/04/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",85500
2019/04/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",33000
2019/04/28,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0403","武田　和美",250000
2019/04/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0403","武田　和美",450000
2019/04/29,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0301","川谷　実",175000
2019/04/29,"J-10004","バインダーB-125","00000016","株式会社広島興産","0301","川谷　実",255000
2019/04/29,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0301","川谷　実",225000
2019/04/29,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2250800
2019/04/29,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2498500
2019/04/29,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",427500
2019/04/29,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1215000
2019/04/29,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1595250
2019/04/29,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",301500
2019/04/29,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",472500
2019/04/30,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0403","武田　和美",50000
2019/04/30,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0403","武田　和美",180000
2019/04/30,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0403","武田　和美",70000
2019/05/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",242250
2019/05/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",684000
2019/05/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3325000
2019/05/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",337600
2019/05/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",236320
2019/05/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",236320
2019/05/01,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",211200
2019/05/01,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",247680
2019/05/01,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",168480
2019/05/01,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",266400
2019/05/01,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",294000
2019/05/01,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",245000
2019/05/01,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",114000
2019/05/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",47500
2019/05/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315900
2019/05/03,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",317250
2019/05/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",45000
2019/05/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",541200
2019/05/03,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",220800
2019/05/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",56250
2019/05/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",145680
2019/05/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",34380
2019/05/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",87450
2019/05/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",93830
2019/05/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",325920
2019/05/04,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",240000
2019/05/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",942000
2019/05/04,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",1560800
2019/05/04,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",780000
2019/05/04,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",145000
2019/05/04,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",77500
2019/05/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",376500
2019/05/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",716300
2019/05/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",289400
2019/05/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",194832
2019/05/04,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",228096
2019/05/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",155520
2019/05/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1147500
2019/05/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",90000
2019/05/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",112500
2019/05/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",209000
2019/05/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",171000
2019/05/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",30000
2019/05/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1082400
2019/05/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",187500
2019/05/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",30850
2019/05/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",7220
2019/05/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",100800
2019/05/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",81000
2019/05/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",81000
2019/05/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",210600
2019/05/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",304000
2019/05/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/05/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",251600
2019/05/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",580160
2019/05/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",245000
2019/05/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",-442000
2019/05/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",688500
2019/05/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1029000
2019/05/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",135830
2019/05/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",71400
2019/05/10,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1245000
2019/05/10,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",95000
2019/05/10,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",120000
2019/05/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",3955200
2019/05/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",3944000
2019/05/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",567640
2019/05/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",613000
2019/05/10,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",50000
2019/05/11,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",525000
2019/05/11,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",206400
2019/05/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",852000
2019/05/11,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",52500
2019/05/11,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",540000
2019/05/11,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",196776
2019/05/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",117000
2019/05/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",336240
2019/05/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/05/11,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/05/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",37200
2019/05/11,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",31000
2019/05/11,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",7200
2019/05/11,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",234000
2019/05/11,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",600000
2019/05/11,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3300000
2019/05/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",295240
2019/05/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",443240
2019/05/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",740000
2019/05/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",232550
2019/05/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",243000
2019/05/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/05/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",225000
2019/05/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",28500
2019/05/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",99750
2019/05/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",66000
2019/05/12,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",210000
2019/05/12,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",194400
2019/05/12,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/05/12,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",38000
2019/05/12,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",108800
2019/05/12,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",85500
2019/05/12,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",88500
2019/05/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/05/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/05/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",959200
2019/05/13,"D-00001","柑橘のど飴","00000002","株式会社岩手産業","0102","佐藤　政夫",20000
2019/05/13,"D-00002","フルーツのど飴","00000002","株式会社岩手産業","0102","佐藤　政夫",69000
2019/05/13,"J-10001","クリアーファイルK-77","00000508","札幌工務店株式会社","0210","川口　七恵",55500
2019/05/13,"J-10002","フロッピーディスクケースH-3.5","00000508","札幌工務店株式会社","0210","川口　七恵",54000
2019/05/13,"J-10005","コンピュータ用紙STKH-15INT","00000508","札幌工務店株式会社","0210","川口　七恵",4500
2019/05/13,"K-10001","全自動洗濯機","00000011","名古屋電機商事株式会社","0302","中村　秀樹",425000
2019/05/13,"S-10011","海苔玉ふりかけ","00000002","株式会社岩手産業","0102","佐藤　政夫",67500
2019/05/13,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/05/13,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",140800
2019/05/13,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",110000
2019/05/13,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",88000
2019/05/13,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",89440
2019/05/13,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",327600
2019/05/15,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000011","名古屋電機商事株式会社","0302","中村　秀樹",220000
2019/05/15,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",240000
2019/05/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",4321520
2019/05/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",4797100
2019/05/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",820800
2019/05/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2332800
2019/05/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",4530450
2019/05/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",578800
2019/05/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",472500
2019/05/16,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000004","群馬事務機株式会社","0201","大田　孝一",2200000
2019/05/16,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000004","群馬事務機株式会社","0201","大田　孝一",3600000
2019/05/17,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000004","群馬事務機株式会社","0201","大田　孝一",1184000
2019/05/17,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",480000
2019/05/17,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",240000
2019/05/17,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1020000
2019/05/17,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",59000
2019/05/17,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",35400
2019/05/17,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",147000
2019/05/23,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",30000
2019/05/23,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",105000
2019/05/23,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",70000
2019/05/25,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0102","佐藤　政夫",132000
2019/05/25,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0102","佐藤　政夫",237600
2019/06/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",242250
2019/06/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",684000
2019/06/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3325000
2019/06/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",113120
2019/06/01,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",209000
2019/06/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",19000
2019/06/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315900
2019/06/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",45000
2019/06/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",541200
2019/06/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",56250
2019/06/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",73680
2019/06/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",21120
2019/06/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",174900
2019/06/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",136480
2019/06/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",465600
2019/06/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",1547000
2019/06/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",208250
2019/06/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",372130
2019/06/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",167280
2019/06/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",194832
2019/06/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",155520
2019/06/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1224000
2019/06/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",126000
2019/06/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",157500
2019/06/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",313500
2019/06/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",188100
2019/06/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",30000
2019/06/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1082400
2019/06/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",187500
2019/06/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",30850
2019/06/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",7220
2019/06/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",157500
2019/06/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",89100
2019/06/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",83700
2019/06/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",377400
2019/06/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",725200
2019/06/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",269500
2019/06/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",0
2019/06/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",918000
2019/06/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1372000
2019/06/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",271660
2019/06/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",85680
2019/06/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",2444000
2019/06/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",142500
2019/06/11,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",216720
2019/06/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",342000
2019/06/11,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",196776
2019/06/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",22500
2019/06/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",18240
2019/06/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/06/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",39060
2019/06/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",189050
2019/06/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",284050
2019/06/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",418000
2019/06/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",134805
2019/06/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",243000
2019/06/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/06/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",225000
2019/06/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",28500
2019/06/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",99750
2019/06/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",82500
2019/06/12,"S-10002","ブイヨン","00000012","大阪事務株式会社","0401","山下　和伸",11640
2019/06/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/06/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/06/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",109000
2019/06/14,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",35000
2019/06/14,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1080000
2019/06/14,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",225000
2019/06/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",75264
2019/06/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",50176
2019/06/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",174048
2019/06/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2122488
2019/06/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2298600
2019/06/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",432630
2019/06/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1117800
2019/06/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1467600
2019/06/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",277300
2019/06/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",434700
2019/06/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",105300
2019/06/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",55860
2019/06/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",60800
2019/06/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/06/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",585060
2019/06/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",507052
2019/06/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/06/16,"O-10018","ヘッドホンステレオNARQ-JR4-Sシルバー","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/06/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",178060
2019/06/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",13440
2019/06/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",56160
2019/06/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",40040
2019/06/18,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/06/18,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",349824
2019/06/18,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",187500
2019/06/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",639036
2019/06/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",930036
2019/06/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",384120
2019/06/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",158080
2019/06/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",274170
2019/06/20,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",30400
2019/06/20,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",79800
2019/06/20,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",66000
2019/06/20,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",237500
2019/06/22,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",1666000
2019/06/22,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",3740000
2019/06/22,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",2352000
2019/06/22,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",212500
2019/06/22,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",1038800
2019/06/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2430000
2019/06/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",124740
2019/06/22,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000002","株式会社岩手産業","0102","佐藤　政夫",338300
2019/06/22,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",75480
2019/06/22,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/06/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",540000
2019/06/22,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",180000
2019/06/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",270000
2019/06/22,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",198000
2019/06/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",180000
2019/06/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",580160
2019/06/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1246560
2019/06/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",1029000
2019/06/23,"S-10031","緑茶","00000012","大阪事務株式会社","0401","山下　和伸",10236
2019/06/23,"S-10032","ダージリン紅茶","00000012","大阪事務株式会社","0401","山下　和伸",9072
2019/06/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",82680
2019/06/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",85300
2019/06/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",69840
2019/06/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",179010
2019/06/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",178752
2019/06/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",85120
2019/06/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",34200
2019/06/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",912000
2019/06/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",312930
2019/06/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",75240
2019/06/25,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",258000
2019/06/25,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",273300
2019/06/25,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/06/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",55800
2019/06/25,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",133000
2019/06/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",234300
2019/06/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",141000
2019/06/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",203040
2019/06/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",345600
2019/06/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",195000
2019/06/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",678960
2019/06/26,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",285000
2019/06/26,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",9500
2019/06/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",74100
2019/06/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",46200
2019/06/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",161500
2019/06/29,"K-10001","全自動洗濯機","00000003","株式会社茨城電機","0201","大田　孝一",153000
2019/06/29,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000003","株式会社茨城電機","0201","大田　孝一",432000
2019/06/29,"O-10001","ＡＶ＆ドルビーサラウンドテレビ３３NATH-33F1","00000003","株式会社茨城電機","0201","大田　孝一",684000
2019/06/29,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000003","株式会社茨城電機","0201","大田　孝一",63000
2019/06/29,"S-10031","緑茶","00000024","東京国際物流株式会社","0210","川口　七恵",10236
2019/06/29,"S-10033","鉄観音鳥龍茶","00000024","東京国際物流株式会社","0210","川口　七恵",9540
2019/06/29,"S-10034","杜仲茶","00000024","東京国際物流株式会社","0210","川口　七恵",10236
2019/06/29,"S-10035","プアル茶","00000024","東京国際物流株式会社","0210","川口　七恵",9312
2019/07/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",242250
2019/07/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",684000
2019/07/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3657500
2019/07/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",141400
2019/07/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",113120
2019/07/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",141400
2019/07/01,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",114000
2019/07/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",47500
2019/07/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",421200
2019/07/03,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",159750
2019/07/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",48000
2019/07/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",519552
2019/07/03,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",112800
2019/07/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",56250
2019/07/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",73680
2019/07/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",19200
2019/07/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",87450
2019/07/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",88712
2019/07/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",325920
2019/07/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",884000
2019/07/04,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",720800
2019/07/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",208250
2019/07/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",338300
2019/07/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",139400
2019/07/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",265680
2019/07/04,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",285120
2019/07/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",172800
2019/07/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1147500
2019/07/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",108000
2019/07/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",112500
2019/07/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",247000
2019/07/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",171000
2019/07/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",30000
2019/07/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1298880
2019/07/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",187500
2019/07/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",30850
2019/07/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",14440
2019/07/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",110250
2019/07/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",81000
2019/07/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",94500
2019/07/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",231660
2019/07/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",304000
2019/07/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/07/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",251600
2019/07/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",870240
2019/07/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",245000
2019/07/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",0
2019/07/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",688500
2019/07/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1372000
2019/07/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",407490
2019/07/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",71400
2019/07/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",1955200
2019/07/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",2430000
2019/07/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",862920
2019/07/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",142500
2019/07/11,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",206400
2019/07/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",342000
2019/07/11,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",218640
2019/07/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",22500
2019/07/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",30400
2019/07/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/07/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",37200
2019/07/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",189050
2019/07/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",284050
2019/07/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",380000
2019/07/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",122550
2019/07/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/07/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",315000
2019/07/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",90000
2019/07/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",19000
2019/07/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",85500
2019/07/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",66000
2019/07/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/07/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/07/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",130800
2019/07/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",62720
2019/07/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",62720
2019/07/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",152292
2019/07/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2070720
2019/07/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2298600
2019/07/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",393300
2019/07/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1117800
2019/07/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1467600
2019/07/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",277300
2019/07/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",434700
2019/07/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",105300
2019/07/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",33516
2019/07/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",48640
2019/07/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",32300
2019/07/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",585060
2019/07/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",390040
2019/07/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/07/16,"O-10018","ヘッドホンステレオNARQ-JR4-Sシルバー","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/07/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",171920
2019/07/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",11520
2019/07/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",62400
2019/07/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36400
2019/07/18,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/07/18,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",327960
2019/07/18,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",187500
2019/07/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",532530
2019/07/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",775030
2019/07/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",384120
2019/07/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",121600
2019/07/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",210900
2019/07/20,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",30400
2019/07/20,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",79800
2019/07/20,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",66000
2019/07/20,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",190000
2019/07/22,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",749700
2019/07/22,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",374000
2019/07/22,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1176000
2019/07/22,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",106250
2019/07/22,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",415520
2019/07/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2430000
2019/07/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",124740
2019/07/22,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000002","株式会社岩手産業","0102","佐藤　政夫",338300
2019/07/22,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",75480
2019/07/22,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/07/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",378000
2019/07/22,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",180000
2019/07/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",198000
2019/07/22,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",198000
2019/07/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",180000
2019/07/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",405
2019/07/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",725200
2019/07/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",2077600
2019/07/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",2058000
2019/07/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",84270
2019/07/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",85300
2019/07/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",69840
2019/07/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",179010
2019/07/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",178752
2019/07/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",91200
2019/07/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",34200
2019/07/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",684000
2019/07/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",312930
2019/07/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",75240
2019/07/25,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",258000
2019/07/25,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",273300
2019/07/25,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",112860
2019/07/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",40920
2019/07/25,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",133000
2019/07/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",234300
2019/07/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",141000
2019/07/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",225600
2019/07/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",345600
2019/07/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",195000
2019/07/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",472320
2019/07/26,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",199500
2019/07/26,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",142500
2019/07/27,"K-10001","全自動洗濯機","00000003","株式会社茨城電機","0201","大田　孝一",76500
2019/07/27,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000003","株式会社茨城電機","0201","大田　孝一",432000
2019/07/27,"O-10001","ＡＶ＆ドルビーサラウンドテレビ３３NATH-33F1","00000003","株式会社茨城電機","0201","大田　孝一",342000
2019/07/27,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000003","株式会社茨城電機","0201","大田　孝一",63000
2019/07/27,"S-10031","緑茶","00000024","東京国際物流株式会社","0210","川口　七恵",2559
2019/07/27,"S-10033","鉄観音鳥龍茶","00000024","東京国際物流株式会社","0210","川口　七恵",2385
2019/07/27,"S-10034","杜仲茶","00000024","東京国際物流株式会社","0210","川口　七恵",1706
2019/07/27,"S-10035","プアル茶","00000024","東京国際物流株式会社","0210","川口　七恵",1552
2019/07/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",38000
2019/07/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",74100
2019/07/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",49500
2019/07/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",313500
2019/08/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",242250
2019/08/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",228000
2019/08/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",2660000
2019/08/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",161600
2019/08/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",113120
2019/08/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",113120
2019/08/01,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",104500
2019/08/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",47500
2019/08/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",315900
2019/08/03,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",106500
2019/08/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",45000
2019/08/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",541200
2019/08/03,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",112800
2019/08/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",56250
2019/08/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",49120
2019/08/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",19200
2019/08/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",87450
2019/08/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",88712
2019/08/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",325920
2019/08/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",221000
2019/08/04,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",720800
2019/08/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",148750
2019/08/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",270640
2019/08/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",111520
2019/08/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",194832
2019/08/04,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",228096
2019/08/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",172800
2019/08/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1147500
2019/08/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",108000
2019/08/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",112500
2019/08/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",209000
2019/08/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",136800
2019/08/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",30000
2019/08/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1082400
2019/08/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",187500
2019/08/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",24680
2019/08/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",5776
2019/08/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",75600
2019/08/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",81000
2019/08/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",48600
2019/08/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",221130
2019/08/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",304000
2019/08/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/08/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",251600
2019/08/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",580160
2019/08/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",245000
2019/08/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",0
2019/08/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",918000
2019/08/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1715000
2019/08/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",135830
2019/08/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",71400
2019/08/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",1955200
2019/08/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",1701000
2019/08/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",287640
2019/08/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",133000
2019/08/11,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",206400
2019/08/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",342000
2019/08/11,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",196776
2019/08/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",22500
2019/08/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",18240
2019/08/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/08/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",37200
2019/08/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",113430
2019/08/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",227240
2019/08/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",304000
2019/08/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",122550
2019/08/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",135000
2019/08/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",225000
2019/08/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",180000
2019/08/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",28500
2019/08/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",99750
2019/08/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",66000
2019/08/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/08/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/08/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",109000
2019/08/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",50176
2019/08/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",25088
2019/08/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",108780
2019/08/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2070720
2019/08/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2298600
2019/08/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",393300
2019/08/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1117800
2019/08/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1467600
2019/08/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",277300
2019/08/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",434700
2019/08/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",105300
2019/08/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",67032
2019/08/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",60800
2019/08/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/08/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",585060
2019/08/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",390040
2019/08/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/08/16,"O-10018","ヘッドホンステレオNARQ-JR4-Sシルバー","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/08/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",122800
2019/08/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",13440
2019/08/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",43680
2019/08/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36400
2019/08/18,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/08/18,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",327960
2019/08/18,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",187500
2019/08/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",639036
2019/08/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",930036
2019/08/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",307296
2019/08/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",158080
2019/08/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",274170
2019/08/20,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",20900
2019/08/20,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",57000
2019/08/20,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",49500
2019/08/20,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",218500
2019/08/22,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",833000
2019/08/22,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",374000
2019/08/22,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1411200
2019/08/22,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",106250
2019/08/22,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",1246560
2019/08/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",1944000
2019/08/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",89100
2019/08/22,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000002","株式会社岩手産業","0102","佐藤　政夫",338300
2019/08/22,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",94350
2019/08/22,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",243000
2019/08/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",405000
2019/08/22,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",180000
2019/08/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",198000
2019/08/22,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",225000
2019/08/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",180000
2019/08/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",405
2019/08/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",580160
2019/08/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1038800
2019/08/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",686000
2019/08/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",82680
2019/08/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",85300
2019/08/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",69840
2019/08/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",157950
2019/08/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",178752
2019/08/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",72960
2019/08/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",19000
2019/08/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",912000
2019/08/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",417240
2019/08/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",75240
2019/08/25,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",258000
2019/08/25,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",273300
2019/08/25,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",118800
2019/08/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",40920
2019/08/25,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",142500
2019/08/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",106500
2019/08/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",141000
2019/08/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",169200
2019/08/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",345600
2019/08/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",195000
2019/08/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",678960
2019/08/26,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",190000
2019/08/26,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",114000
2019/08/27,"K-10001","全自動洗濯機","00000003","株式会社茨城電機","0201","大田　孝一",153000
2019/08/27,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000003","株式会社茨城電機","0201","大田　孝一",432000
2019/08/27,"O-10001","ＡＶ＆ドルビーサラウンドテレビ３３NATH-33F1","00000003","株式会社茨城電機","0201","大田　孝一",684000
2019/08/27,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000003","株式会社茨城電機","0201","大田　孝一",63000
2019/08/27,"S-10031","緑茶","00000024","東京国際物流株式会社","0210","川口　七恵",5971
2019/08/27,"S-10033","鉄観音鳥龍茶","00000024","東京国際物流株式会社","0210","川口　七恵",5565
2019/08/27,"S-10034","杜仲茶","00000024","東京国際物流株式会社","0210","川口　七恵",5971
2019/08/27,"S-10035","プアル茶","00000024","東京国際物流株式会社","0210","川口　七恵",5432
2019/08/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",34200
2019/08/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",74100
2019/08/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",49500
2019/08/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",161500
2019/09/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",323000
2019/09/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",912000
2019/09/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3990000
2019/09/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",80800
2019/09/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",84840
2019/09/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",121200
2019/09/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",199500
2019/09/03,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",210600
2019/09/03,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",117150
2019/09/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",48000
2019/09/03,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",541200
2019/09/03,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",124080
2019/09/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",60000
2019/09/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",67540
2019/09/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",21120
2019/09/03,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",75276
2019/09/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",81090
2019/09/03,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",80784
2019/09/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",87006
2019/09/03,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",73440
2019/09/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",79152
2019/09/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",148750
2019/09/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",507450
2019/09/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",278800
2019/09/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1147500
2019/09/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",90000
2019/09/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",112500
2019/09/05,"S-10001","鰹節ギフト用","00000001","太平洋販売株式会社","0102","佐藤　政夫",63000
2019/09/05,"S-10002","ブイヨン","00000001","太平洋販売株式会社","0102","佐藤　政夫",54000
2019/09/05,"S-10003","乾燥海草サラダ","00000001","太平洋販売株式会社","0102","佐藤　政夫",54000
2019/09/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",95000
2019/09/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",171000
2019/09/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",30000
2019/09/08,"J-10004","バインダーB-125","00000004","群馬事務機株式会社","0201","大田　孝一",1082400
2019/09/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",187500
2019/09/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",30850
2019/09/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",7220
2019/09/08,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",870240
2019/09/08,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",147000
2019/09/08,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",2058000
2019/09/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",110250
2019/09/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",94500
2019/09/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",94500
2019/09/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",210600
2019/09/09,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",165120
2019/09/09,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",174912
2019/09/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",304000
2019/09/09,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",95040
2019/09/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/09/09,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",29760
2019/09/09,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",123400
2019/09/10,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",19000
2019/09/10,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",91200
2019/09/10,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",33000
2019/09/10,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",629000
2019/09/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",1466400
2019/09/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",1606500
2019/09/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",2430000
2019/09/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",575280
2019/09/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",152000
2019/09/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",427500
2019/09/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",22500
2019/09/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",24320
2019/09/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",75620
2019/09/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",284050
2019/09/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",380000
2019/09/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",122550
2019/09/12,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",120000
2019/09/12,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",218640
2019/09/12,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",150000
2019/09/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",135160
2019/09/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",135160
2019/09/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",135160
2019/09/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",87808
2019/09/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",50176
2019/09/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",152292
2019/09/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2070720
2019/09/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2298600
2019/09/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",409032
2019/09/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1117800
2019/09/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1526304
2019/09/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",277300
2019/09/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",434700
2019/09/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",105300
2019/09/16,"J-10004","バインダーB-125","00000007","東京事務機販売株式会社","0204","北野　紀男",67032
2019/09/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",60800
2019/09/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/09/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",546056
2019/09/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",195020
2019/09/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",321440
2019/09/16,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",216000
2019/09/16,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/09/16,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/09/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",184200
2019/09/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",11520
2019/09/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",62400
2019/09/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36400
2019/09/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",426024
2019/09/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",620024
2019/09/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",345708
2019/09/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",158080
2019/09/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",274170
2019/09/19,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",190080
2019/09/19,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",95040
2019/09/19,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",418500
2019/09/19,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",279000
2019/09/19,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",279000
2019/09/20,"C-00001","プリントＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",25500
2019/09/20,"C-00002","アンダーシャツ（綿素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",76500
2019/09/20,"C-00003","インポートＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",29750
2019/09/20,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",999600
2019/09/20,"K-10002","スチームアイロンIRS-5000CL-WT","00000002","株式会社岩手産業","0102","佐藤　政夫",170000
2019/09/20,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",748000
2019/09/20,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1411200
2019/09/20,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",106250
2019/09/20,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",831040
2019/09/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2430000
2019/09/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",142560
2019/09/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",351000
2019/09/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",234000
2019/09/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",234000
2019/09/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",98750
2019/09/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",870240
2019/09/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1246560
2019/09/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",2058000
2019/09/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",81090
2019/09/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",87006
2019/09/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",79152
2019/09/23,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",237500
2019/09/24,"J-10001","クリアーファイルK-77","00000014","京都システム株式会社","0403","武田　和美",157950
2019/09/24,"J-10004","バインダーB-125","00000014","京都システム株式会社","0403","武田　和美",167580
2019/09/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",91200
2019/09/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",28500
2019/09/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",684000
2019/09/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",312930
2019/09/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",56430
2019/09/26,"J-10001","クリアーファイルK-77","00000008","神奈川物産株式会社","0205","北野　まゆみ",213000
2019/09/26,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",216720
2019/09/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",150000
2019/09/26,"J-10004","バインダーB-125","00000008","神奈川物産株式会社","0205","北野　まゆみ",180480
2019/09/26,"J-10004","バインダーB-125","00000016","株式会社広島興産","0501","岸川　良介",345600
2019/09/26,"J-10004","バインダーB-125","00000020","鹿児島文具","0602","倉吉　章次",229572
2019/09/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",187500
2019/09/26,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",124740
2019/09/26,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",39060
2019/09/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",619920
2019/09/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",28500
2019/09/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",85500
2019/09/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",49500
2019/10/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",242250
2019/10/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",684000
2019/10/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3325000
2019/10/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",161600
2019/10/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",121200
2019/10/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",121200
2019/10/01,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",114000
2019/10/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",57000
2019/10/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",45000
2019/10/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",56250
2019/10/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",73680
2019/10/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",19200
2019/10/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",87450
2019/10/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",88712
2019/10/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",325920
2019/10/04,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",442000
2019/10/04,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",901000
2019/10/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",208250
2019/10/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",338300
2019/10/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",139400
2019/10/04,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",194832
2019/10/04,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",228096
2019/10/04,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",155520
2019/10/05,"D-00001","柑橘のど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",20000
2019/10/05,"J-10002","フロッピーディスクケースH-3.5","00000005","埼玉商事株式会社","0202","山本　義治",180000
2019/10/05,"J-10005","コンピュータ用紙STKH-15INT","00000005","埼玉商事株式会社","0202","山本　義治",60000
2019/10/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1147500
2019/10/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",108000
2019/10/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",135000
2019/10/05,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",11250
2019/10/05,"S-10022","茶漬け（うに）","00000001","太平洋販売株式会社","0102","佐藤　政夫",14400
2019/10/05,"S-10023","茶漬け（シャケ）","00000001","太平洋販売株式会社","0102","佐藤　政夫",10800
2019/10/05,"SET-S01","贈答ギフトセット","00000030","渋谷フラワー株式会社","0209","清水　大輔",1710000
2019/10/05,"SET-S02","贈答ふりかけ３点セット","00000030","渋谷フラワー株式会社","0209","清水　大輔",243000
2019/10/05,"SET-S03","贈答コーヒーギフトセット","00000030","渋谷フラワー株式会社","0209","清水　大輔",638100
2019/10/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",209000
2019/10/05,"T-00001","花１００００円ＳＥＴ","00000030","渋谷フラワー株式会社","0209","清水　大輔",500000
2019/10/05,"T-00002","観葉植物","00000030","渋谷フラワー株式会社","0209","清水　大輔",340000
2019/10/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",171000
2019/10/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",30000
2019/10/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",187500
2019/10/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",30850
2019/10/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",7220
2019/10/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",100800
2019/10/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",81000
2019/10/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",81000
2019/10/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",304000
2019/10/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/10/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",251600
2019/10/09,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",725200
2019/10/09,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",245000
2019/10/09,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000002","株式会社岩手産業","0102","佐藤　政夫",0
2019/10/09,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",688500
2019/10/09,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",1372000
2019/10/09,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000002","株式会社岩手産業","0102","佐藤　政夫",271660
2019/10/09,"O-10010","フルオートプレイヤーNASL-J80R-K","00000002","株式会社岩手産業","0102","佐藤　政夫",71400
2019/10/10,"J-10002","フロッピーディスクケースH-3.5","00000508","札幌工務店株式会社","0210","川口　七恵",54000
2019/10/10,"J-10005","コンピュータ用紙STKH-15INT","00000508","札幌工務店株式会社","0210","川口　七恵",4500
2019/10/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",1955200
2019/10/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",1944000
2019/10/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",287640
2019/10/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",133000
2019/10/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",342000
2019/10/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",22500
2019/10/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",18240
2019/10/11,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/10/11,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",37200
2019/10/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",151240
2019/10/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",227240
2019/10/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",380000
2019/10/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",122550
2019/10/11,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",243000
2019/10/11,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/10/11,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",225000
2019/10/12,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",28500
2019/10/12,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",99750
2019/10/12,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",66000
2019/10/12,"D-00001","柑橘のど飴","00000002","株式会社岩手産業","0102","佐藤　政夫",17000
2019/10/12,"S-10003","乾燥海草サラダ","00000002","株式会社岩手産業","0102","佐藤　政夫",2550
2019/10/12,"S-10011","海苔玉ふりかけ","00000002","株式会社岩手産業","0102","佐藤　政夫",57300
2019/10/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/10/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",139520
2019/10/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",109000
2019/10/14,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000004","群馬事務機株式会社","0201","大田　孝一",2090000
2019/10/14,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000004","群馬事務機株式会社","0201","大田　孝一",2280000
2019/10/14,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000004","群馬事務機株式会社","0201","大田　孝一",1406000
2019/10/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",62720
2019/10/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",37632
2019/10/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",152292
2019/10/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2070720
2019/10/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2298600
2019/10/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",393300
2019/10/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1117800
2019/10/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1467600
2019/10/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",277300
2019/10/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",434700
2019/10/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",60800
2019/10/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/10/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",585060
2019/10/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",312032
2019/10/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/10/16,"O-10018","ヘッドホンステレオNARQ-JR4-Sシルバー","00000016","株式会社広島興産","0501","岸川　良介",160720
2019/10/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",171920
2019/10/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",11520
2019/10/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",49920
2019/10/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",36400
2019/10/18,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",108000
2019/10/18,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",187500
2019/10/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",532530
2019/10/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",775030
2019/10/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",307296
2019/10/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",145920
2019/10/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",253080
2019/10/20,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",30400
2019/10/20,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",79800
2019/10/20,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",59400
2019/10/20,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",218500
2019/10/22,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",833000
2019/10/22,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",374000
2019/10/22,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1411200
2019/10/22,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",85000
2019/10/22,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",1038800
2019/10/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2430000
2019/10/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",124740
2019/10/22,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000002","株式会社岩手産業","0102","佐藤　政夫",338300
2019/10/22,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",75480
2019/10/22,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",243000
2019/10/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",378000
2019/10/22,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",180000
2019/10/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",198000
2019/10/22,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",198000
2019/10/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",180000
2019/10/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",4050
2019/10/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",435120
2019/10/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1038800
2019/10/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",686000
2019/10/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",82680
2019/10/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",85300
2019/10/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",69840
2019/10/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",85120
2019/10/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",34200
2019/10/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",684000
2019/10/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",312930
2019/10/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",56430
2019/10/25,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/10/25,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",40920
2019/10/25,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",123500
2019/10/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",141000
2019/10/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",195000
2019/10/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",649440
2019/10/26,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",237500
2019/10/26,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",190000
2019/10/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",34200
2019/10/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",74100
2019/10/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",46200
2019/10/28,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",190000
2019/11/01,"K-10001","全自動洗濯機","00000006","株式会社千葉デンキ","0203","河合　正信",323000
2019/11/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",912000
2019/11/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",4322500
2019/11/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",88880
2019/11/01,"S-10012","鱈子ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",88880
2019/11/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",121200
2019/11/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",294500
2019/11/03,"J-10003","ワープロ用感熱紙WRP-123","00000007","東京事務機販売株式会社","0204","北野　紀男",48000
2019/11/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",60000
2019/11/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",79820
2019/11/03,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",24960
2019/11/03,"S-10033","鉄観音鳥龍茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",76752
2019/11/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",82680
2019/11/03,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",82368
2019/11/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",88712
2019/11/03,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",74880
2019/11/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",80704
2019/11/04,"O-10011","フルレンジスピーカーシステムNASB-S30-K","00000002","株式会社岩手産業","0102","佐藤　政夫",178500
2019/11/04,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000002","株式会社岩手産業","0102","佐藤　政夫",541280
2019/11/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",306680
2019/11/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1224000
2019/11/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",90000
2019/11/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",90000
2019/11/05,"S-10001","鰹節ギフト用","00000001","太平洋販売株式会社","0102","佐藤　政夫",69300
2019/11/05,"S-10002","ブイヨン","00000001","太平洋販売株式会社","0102","佐藤　政夫",59400
2019/11/05,"S-10003","乾燥海草サラダ","00000001","太平洋販売株式会社","0102","佐藤　政夫",59400
2019/11/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",142500
2019/11/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",171000
2019/11/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",30000
2019/11/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",187500
2019/11/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",30850
2019/11/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",18050
2019/11/08,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",870240
2019/11/08,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",147000
2019/11/08,"O-10006","文字放送内蔵テレビNATH-19T2","00000017","テック高松株式会社","0502","西本　明美",2058000
2019/11/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",126000
2019/11/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",108000
2019/11/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",108000
2019/11/09,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",316160
2019/11/09,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",106920
2019/11/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",285000
2019/11/09,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",33480
2019/11/09,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",92550
2019/11/10,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",20900
2019/11/10,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",85500
2019/11/10,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",36300
2019/11/10,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",754800
2019/11/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",4154800
2019/11/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",2065500
2019/11/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",2430000
2019/11/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",719100
2019/11/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",142500
2019/11/11,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",427500
2019/11/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",22500
2019/11/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",30400
2019/11/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",151240
2019/11/11,"O-10015","スピーカーシステムNASB-MX7-M","00000006","株式会社千葉デンキ","0203","河合　正信",284050
2019/11/11,"O-10020","ヘッドホンステレオNARX-SR24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",380000
2019/11/11,"O-10021","ヘッドホンステレオNARQ-JA65-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",122550
2019/11/12,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",120000
2019/11/12,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",150000
2019/11/12,"S-10011","海苔玉ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",143880
2019/11/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",143880
2019/11/12,"S-10013","胡麻塩ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",143880
2019/11/15,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000017","テック高松株式会社","0502","西本　明美",125440
2019/11/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",37632
2019/11/15,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000017","テック高松株式会社","0502","西本　明美",152292
2019/11/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2588400
2019/11/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2298600
2019/11/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",393300
2019/11/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1117800
2019/11/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1467600
2019/11/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",277300
2019/11/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",434700
2019/11/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",60800
2019/11/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",38000
2019/11/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",546056
2019/11/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",156016
2019/11/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",353584
2019/11/16,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/11/16,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/11/16,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",270000
2019/11/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",184200
2019/11/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",19200
2019/11/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",68640
2019/11/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",40040
2019/11/18,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000013","梅田商事株式会社","0402","牧田　和彦",745542
2019/11/18,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000013","梅田商事株式会社","0402","牧田　和彦",1085042
2019/11/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",326502
2019/11/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",182400
2019/11/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",316350
2019/11/19,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",209088
2019/11/19,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",86400
2019/11/19,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",472500
2019/11/19,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",315000
2019/11/19,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",315000
2019/11/20,"C-00001","プリントＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",25500
2019/11/20,"C-00002","アンダーシャツ（綿素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",76500
2019/11/20,"C-00003","インポートＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",29750
2019/11/20,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",999600
2019/11/20,"K-10002","スチームアイロンIRS-5000CL-WT","00000002","株式会社岩手産業","0102","佐藤　政夫",170000
2019/11/20,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",1870000
2019/11/20,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1176000
2019/11/20,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",106250
2019/11/20,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",1038800
2019/11/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2916000
2019/11/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",124740
2019/11/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",351000
2019/11/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",234000
2019/11/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",234000
2019/11/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",98750
2019/11/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",1160320
2019/11/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1662080
2019/11/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",2744000
2019/11/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",82680
2019/11/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",88712
2019/11/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",80704
2019/11/23,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",266000
2019/11/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",97280
2019/11/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",30400
2019/11/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",1368000
2019/11/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",625860
2019/11/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",112860
2019/11/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",126000
2019/11/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",151200
2019/11/26,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",117480
2019/11/26,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",36740
2019/11/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",584496
2019/11/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",27000
2019/11/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",81000
2019/11/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",37800
2019/12/01,"C-00001","プリントＴシャツ（コットン素材）","00000001","太平洋販売株式会社","0102","佐藤　政夫",17820
2019/12/01,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000006","株式会社千葉デンキ","0203","河合　正信",1026000
2019/12/01,"O-10006","文字放送内蔵テレビNATH-19T2","00000006","株式会社千葉デンキ","0203","河合　正信",3591000
2019/12/01,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",72800
2019/12/01,"S-10013","胡麻塩ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",109200
2019/12/01,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",188100
2019/12/03,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",48000
2019/12/03,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",66240
2019/12/03,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",74360
2019/12/03,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",74048
2019/12/03,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",79872
2019/12/03,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",72592
2019/12/04,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000002","株式会社岩手産業","0102","佐藤　政夫",250920
2019/12/05,"K-10001","全自動洗濯機","00000005","埼玉商事株式会社","0202","山本　義治",1032750
2019/12/05,"K-10002","スチームアイロンIRS-5000CL-WT","00000005","埼玉商事株式会社","0202","山本　義治",97200
2019/12/05,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000005","埼玉商事株式会社","0202","山本　義治",121500
2019/12/05,"S-10001","鰹節ギフト用","00000001","太平洋販売株式会社","0102","佐藤　政夫",33600
2019/12/05,"S-10003","乾燥海草サラダ","00000001","太平洋販売株式会社","0102","佐藤　政夫",51030
2019/12/05,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",94050
2019/12/08,"J-10002","フロッピーディスクケースH-3.5","00000007","東京事務機販売株式会社","0204","北野　紀男",153900
2019/12/08,"J-10003","ワープロ用感熱紙WRP-123","00000004","群馬事務機株式会社","0201","大田　孝一",25500
2019/12/08,"J-10005","コンピュータ用紙STKH-15INT","00000004","群馬事務機株式会社","0201","大田　孝一",150000
2019/12/08,"J-10008","三角スケール50-SRM","00000007","東京事務機販売株式会社","0204","北野　紀男",27750
2019/12/08,"J-10009","コンパス162KMPS","00000007","東京事務機販売株式会社","0204","北野　紀男",9720
2019/12/08,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",913752
2019/12/08,"S-10001","鰹節ギフト用","00000010","石川販売株式会社","0302","中村　秀樹",100800
2019/12/08,"S-10002","ブイヨン","00000010","石川販売株式会社","0302","中村　秀樹",87480
2019/12/08,"S-10003","乾燥海草サラダ","00000010","石川販売株式会社","0302","中村　秀樹",87480
2019/12/09,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",189600
2019/12/09,"J-10001","クリアーファイルK-77","00000020","鹿児島文具","0602","倉吉　章次",129780
2019/12/09,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",74760
2019/12/09,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",256500
2019/12/09,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",23380
2019/12/10,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",17280
2019/12/10,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",679320
2019/12/10,"O-10002","ＡＶサラウンドテレビ２９NATH-29K1S","00000009","新潟工業株式会社","0301","川谷　実",1466400
2019/12/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000002","株式会社岩手産業","0102","佐藤　政夫",1445850
2019/12/10,"O-10004","文字放送内蔵テレビNATH-29TA2","00000011","名古屋電機商事株式会社","0302","中村　秀樹",2187000
2019/12/10,"O-10008","ニューオーディオコンポCD650NASC-CD650-K","00000011","名古屋電機商事株式会社","0302","中村　秀樹",647190
2019/12/10,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",145350
2019/12/11,"J-10005","コンピュータ用紙STKH-15INT","00000007","東京事務機販売株式会社","0204","北野　紀男",18000
2019/12/11,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",27300
2019/12/11,"O-10013","ステレオグラフィックイコライザーNASH-E70A-K","00000006","株式会社千葉デンキ","0203","河合　正信",102087
2019/12/12,"J-10003","ワープロ用感熱紙WRP-123","00000020","鹿児島文具","0602","倉吉　章次",100000
2019/12/12,"J-10005","コンピュータ用紙STKH-15INT","00000020","鹿児島文具","0602","倉吉　章次",120000
2019/12/12,"S-10012","鱈子ふりかけ","00000012","大阪事務株式会社","0401","山下　和伸",121520
2019/12/15,"O-10024","ステレオラジオNARX-FM14-Wホワイト","00000017","テック高松株式会社","0502","西本　明美",45156
2019/12/15,"SET-J01","事務用品ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1863680
2019/12/15,"SET-J02","用紙ビジネスパック","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",2068800
2019/12/15,"SET-S01","贈答ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",375187
2019/12/15,"SET-S02","贈答ふりかけ３点セット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1006000
2019/12/15,"SET-S03","贈答コーヒーギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",1400101
2019/12/15,"SET-S04","贈答お茶漬けセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",249600
2019/12/15,"SET-S05","贈答健康茶ギフトセット","00000021","高松屋百貨店株式会社","0207","坂井　貴祐",391200
2019/12/16,"J-10001","クリアーファイルK-77","00000007","東京事務機販売株式会社","0204","北野　紀男",104280
2019/12/16,"J-10006","付箋シール２色HS-002","00000007","東京事務機販売株式会社","0204","北野　紀男",54600
2019/12/16,"J-10007","メモ用便箋MB-120","00000007","東京事務機販売株式会社","0204","北野　紀男",34200
2019/12/16,"O-10012","フルレンジスピーカーシステムNASB-S50-K","00000016","株式会社広島興産","0501","岸川　良介",491442
2019/12/16,"O-10014","コンポーネントテレフォンNASH-TL80-K","00000016","株式会社広島興産","0501","岸川　良介",210618
2019/12/16,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000016","株式会社広島興産","0501","岸川　良介",289290
2019/12/16,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",206550
2019/12/16,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",243000
2019/12/16,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",243000
2019/12/17,"J-10006","付箋シール２色HS-002","00000008","神奈川物産株式会社","0205","北野　まゆみ",165600
2019/12/17,"J-10007","メモ用便箋MB-120","00000008","神奈川物産株式会社","0205","北野　まゆみ",12040
2019/12/17,"J-10008","三角スケール50-SRM","00000008","神奈川物産株式会社","0205","北野　まゆみ",56100
2019/12/17,"J-10009","コンパス162KMPS","00000008","神奈川物産株式会社","0205","北野　まゆみ",32800
2019/12/18,"O-10009","フルオートプレイヤーNASL-J100R-K","00000013","梅田商事株式会社","0402","牧田　和彦",311130
2019/12/18,"O-10023","ステレオラジオNARX-FM14-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",153216
2019/12/18,"O-10025","ステレオラジオNARX-FM24-Kブラック","00000006","株式会社千葉デンキ","0203","河合　正信",265734
2019/12/19,"S-10034","杜仲茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",170880
2019/12/19,"S-10035","プアル茶","00000001","太平洋販売株式会社","0102","佐藤　政夫",77760
2019/12/19,"S-10041","インスタントコーヒー","00000001","太平洋販売株式会社","0102","佐藤　政夫",376650
2019/12/19,"S-10042","健康コーヒー用シュガー","00000001","太平洋販売株式会社","0102","佐藤　政夫",251100
2019/12/19,"S-10043","健康クリームミルク","00000001","太平洋販売株式会社","0102","佐藤　政夫",251100
2019/12/20,"C-00001","プリントＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",22950
2019/12/20,"C-00002","アンダーシャツ（綿素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",68850
2019/12/20,"C-00003","インポートＴシャツ（コットン素材）","00000002","株式会社岩手産業","0102","佐藤　政夫",26770
2019/12/20,"K-10001","全自動洗濯機","00000018","株式会社福岡屋","0601","春日　憲彦",899640
2019/12/20,"K-10002","スチームアイロンIRS-5000CL-WT","00000002","株式会社岩手産業","0102","佐藤　政夫",168300
2019/12/20,"K-10003","４ドア冷蔵庫NANR-D32-TWレッド","00000002","株式会社岩手産業","0102","佐藤　政夫",673200
2019/12/20,"K-10004","４ドア冷蔵庫NANR-D35A/N-KUブラック","00000018","株式会社福岡屋","0601","春日　憲彦",1270080
2019/12/20,"K-10006","電気ジャーポットZJ21A-Wホワイト","00000002","株式会社岩手産業","0102","佐藤　政夫",95625
2019/12/20,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000018","株式会社福岡屋","0601","春日　憲彦",747936
2019/12/22,"O-10004","文字放送内蔵テレビNATH-29TA2","00000005","埼玉商事株式会社","0202","山本　義治",2187000
2019/12/22,"O-10009","フルオートプレイヤーNASL-J100R-K","00000005","埼玉商事株式会社","0202","山本　義治",144342
2019/12/22,"S-10041","インスタントコーヒー","00000010","石川販売株式会社","0302","中村　秀樹",315900
2019/12/22,"S-10042","健康コーヒー用シュガー","00000010","石川販売株式会社","0302","中村　秀樹",210600
2019/12/22,"S-10043","健康クリームミルク","00000010","石川販売株式会社","0302","中村　秀樹",210600
2019/12/22,"U-10002","化粧箱","00000010","石川販売株式会社","0302","中村　秀樹",98750
2019/12/23,"K-10005","３ドア冷蔵庫NANR-C31A-Wホワイト","00000016","株式会社広島興産","0501","岸川　良介",913752
2019/12/23,"O-10003","ＡＶサラウンドテレビ２６NATH-26K1S","00000016","株式会社広島興産","0501","岸川　良介",1308888
2019/12/23,"O-10006","文字放送内蔵テレビNATH-19T2","00000016","株式会社広島興産","0501","岸川　良介",2160900
2019/12/23,"S-10033","鉄観音鳥龍茶","00000012","大阪事務株式会社","0401","山下　和伸",74360
2019/12/23,"S-10034","杜仲茶","00000012","大阪事務株式会社","0401","山下　和伸",79872
2019/12/23,"S-10035","プアル茶","00000012","大阪事務株式会社","0401","山下　和伸",72592
2019/12/23,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",222300
2019/12/24,"J-10006","付箋シール２色HS-002","00000014","京都システム株式会社","0403","武田　和美",65520
2019/12/24,"J-10007","メモ用便箋MB-120","00000014","京都システム株式会社","0403","武田　和美",20520
2019/12/24,"O-10005","文字放送内蔵テレビNATH-26TA2","00000006","株式会社千葉デンキ","0203","河合　正信",820800
2019/12/24,"O-10007","ニューオーディオコンポCD300NASC-CD300-K","00000006","株式会社千葉デンキ","0203","河合　正信",375516
2019/12/24,"O-10009","フルオートプレイヤーNASL-J100R-K","00000006","株式会社千葉デンキ","0203","河合　正信",67716
2019/12/26,"J-10003","ワープロ用感熱紙WRP-123","00000016","株式会社広島興産","0501","岸川　良介",125500
2019/12/26,"J-10005","コンピュータ用紙STKH-15INT","00000016","株式会社広島興産","0501","岸川　良介",150600
2019/12/26,"J-10006","付箋シール２色HS-002","00000020","鹿児島文具","0602","倉吉　章次",117480
2019/12/26,"J-10007","メモ用便箋MB-120","00000020","鹿児島文具","0602","倉吉　章次",36740
2019/12/26,"O-10017","ヘッドホンステレオNARQ-JR4-Kブラック","00000011","名古屋電機商事株式会社","0302","中村　秀樹",557928
2019/12/28,"C-00001","プリントＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",27648
2019/12/28,"C-00002","アンダーシャツ（綿素材）","00000023","T-SHOP株式会社","0206","小川　栄子",80352
2019/12/28,"C-00003","インポートＴシャツ（コットン素材）","00000023","T-SHOP株式会社","0206","小川　栄子",48384
2019/12/29,"D-00001","柑橘のど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",16362
2019/12/29,"D-00001","柑橘のど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",16362
2019/12/29,"D-00001","柑橘のど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",16362
2019/12/29,"D-00001","柑橘のど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",16362
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"D-00002","フルーツのど飴","00000001","太平洋販売株式会社","0102","佐藤　政夫",18786
2019/12/29,"J-10002","フロッピーディスクケースH-3.5","00000005","埼玉商事株式会社","0202","山本　義治",145800
2019/12/29,"J-10005","コンピュータ用紙STKH-15INT","00000005","埼玉商事株式会社","0202","山本　義治",6000
2019/12/29,"S-10001","鰹節ギフト用","00000104","川崎商会株式会社","0404","田中　靖人",21350
2019/12/29,"S-10011","海苔玉ふりかけ","00000001","太平洋販売株式会社","0102","佐藤　政夫",10920
2019/12/29,"S-10022","茶漬け（うに）","00000001","太平洋販売株式会社","0102","佐藤　政夫",11640
2019/12/29,"S-10023","茶漬け（シャケ）","00000001","太平洋販売株式会社","0102","佐藤　政夫",8700
2019/12/29,"SET-S01","贈答ギフトセット","00000030","渋谷フラワー株式会社","0209","清水　大輔",746400
2019/12/29,"SET-S02","贈答ふりかけ３点セット","00000030","渋谷フラワー株式会社","0209","清水　大輔",116666
2019/12/29,"SET-S02","贈答ふりかけ３点セット","00000104","川崎商会株式会社","0404","田中　靖人",540906
2019/12/29,"SET-S03","贈答コーヒーギフトセット","00000030","渋谷フラワー株式会社","0209","清水　大輔",306383
2019/12/29,"SET-S04","贈答お茶漬けセット","00000104","川崎商会株式会社","0404","田中　靖人",131600
2019/12/29,"T-00001","花１００００円ＳＥＴ","00000022","新宿フラワー株式会社","0209","清水　大輔",94050
2019/12/29,"T-00001","花１００００円ＳＥＴ","00000030","渋谷フラワー株式会社","0209","清水　大輔",218250
2019/12/29,"T-00002","観葉植物","00000022","新宿フラワー株式会社","0209","清水　大輔",42750
2019/12/29,"T-00002","観葉植物","00000030","渋谷フラワー株式会社","0209","清水　大輔",148410`

}
